import { request } from '../../../common/src/legacy/services/httpSessionService';
import {
  CreateFlowPayload,
  FlowsAPIAnswers,
  FlowsAPIAnswerError,
  FlowsAPIAnswerSuccess,
} from '../types/ApiTypes';
import { FlowsResponse } from '../types/FlowsTypes';

/**
 *
 * @param {*} flowId id for the flow type (advisory convo || risk-analysis)
 * @param {*} sessionId SessionId for the session to answer
 * @param {*} answers A group of answers that need valdation
 *
 */
export const sendFlowAnswerByFlowId = async (
  flowId: string,
  sessionId: string,
  answers: FlowsAPIAnswers,
): Promise<[FlowsAPIAnswerSuccess | FlowsAPIAnswerError, number]> => {
  const path = `v1/api/flows/${flowId}/conversations/${sessionId}/answers`;
  const [resp, status] = await request({
    path,
    method: 'POST',
    payload: answers,
  });
  return [resp, status];
};

export const createFlowByFlowId = async (
  flowId: string,
  payload: CreateFlowPayload,
): Promise<[FlowsResponse, number]> => {
  const path = `v1/api/flows/${flowId}/conversations`;
  const [resp, status] = await request({ path, method: 'POST', payload });
  return [resp, status];
};
